var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 63,
    viewBox: "0 0 55 63",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8813_13605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3438 31.5C31.4878 31.5 35.462 29.8538 38.3923 26.9235C41.3226 23.9933 42.9688 20.019 42.9688 15.875C42.9688 11.731 41.3226 7.75671 38.3923 4.82646C35.462 1.8962 31.4878 0.25 27.3438 0.25C23.1997 0.25 19.2255 1.8962 16.2952 4.82646C13.365 7.75671 11.7188 11.731 11.7188 15.875C11.7188 20.019 13.365 23.9933 16.2952 26.9235C19.2255 29.8538 23.1997 31.5 27.3438 31.5ZM21.7651 37.3594C9.74121 37.3594 0 47.1006 0 59.1245C0 61.1265 1.62354 62.75 3.62549 62.75H51.062C53.064 62.75 54.6875 61.1265 54.6875 59.1245C54.6875 47.1006 44.9463 37.3594 32.9224 37.3594H21.7651Z",
    fill: "#220D50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8813_13605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.6875,
    height: 62.5,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileAvatar);
export default __webpack_public_path__ + "static/media/ProfileAvatar.58f3baa1084aa4ec527afcc158e36709.svg";
export { ForwardRef as ReactComponent };